import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  trailerType: null,
  pickup: null,
  delivery: null,
  pickupRadius: null,
  pickupDate: null,
  deliveryDate: null,
  deliveryRadius: null,
  searchType: "market_potential",
};

const currentSearchSlice = createSlice({
  name: "currentSearch",
  initialState,
  reducers: {
    clearCurrentSearch: () => {
      return initialState;
    },
    setCurrentSearch: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
});

export const { clearCurrentSearch, setCurrentSearch } = currentSearchSlice.actions;
export default currentSearchSlice.reducer;
